import { formatDate } from '@sparkpost/report-builder/helpers/date';
import _ from 'lodash';
import React from 'react';
import ActionPopover from 'src/components/actionPopover';
import OGOnlyWrapper from 'src/components/hibana/OGOnlyWrapper';
import { PageLink } from 'src/components/links';
import { Box, Panel, Stack, Tag } from 'src/components/matchbox';
import { Heading } from 'src/components/text';
import { setSubaccountQuery } from 'src/helpers/subaccounts';
import { routeNamespace } from '../constants/routes';
// TODO: Remove css module
// eslint-disable-next-line local/no-css-module-import
import styles from './RecentActivity.module.scss';

const RecentActivity = (props) => {
  const { hasActionButtons, templates, onToggleDeleteModal, onToggleDuplicateModal } = props;
  const descendingSortedTemplates = _.orderBy(templates, 'last_update_time', 'desc');

  if (templates.length < 3) {
    return null;
  }

  return (
    <Box mb="500">
      <Stack space="400">
        <Heading as="h2" looksLike="h3">
          Recent Activity
        </Heading>

        <div className={styles.RecentActivity} role="list">
          {descendingSortedTemplates.map((template, index) => {
            const version = template.list_status === 'draft' ? 'draft' : 'published';

            if (index <= 3) {
              return (
                <div
                  role="listitem"
                  className={styles.ListItem}
                  key={`recent-activity-template-${index}`}
                >
                  <Panel.LEGACY className={styles.Panel} accent>
                    <div className={styles.PanelContent}>
                      <Panel.LEGACY.Section>
                        <OGOnlyWrapper as="div" className={styles.PanelStack}>
                          <Stack>
                            <div>
                              {template.list_status === 'published' ||
                              template.list_status === 'published_with_draft' ? (
                                <Tag>Published</Tag>
                              ) : (
                                <Tag>Draft</Tag>
                              )}
                            </div>

                            <PageLink
                              className={styles.TemplateName}
                              to={`/${routeNamespace}/edit/${
                                template.id
                              }/${version}/content${setSubaccountQuery(template.subaccount_id)}`}
                            >
                              {template.name}
                            </PageLink>
                          </Stack>
                        </OGOnlyWrapper>
                      </Panel.LEGACY.Section>

                      <Panel.LEGACY.Section paddingTop="200" paddingBottom="200">
                        <div className={styles.Meta}>
                          <div className={styles.Date}>
                            <span>Updated&nbsp;</span>

                            {formatDate.useMomentInput(template.last_update_time)}
                          </div>

                          {hasActionButtons && (
                            <div className={styles.Actions}>
                              <ActionPopover
                                actions={[
                                  {
                                    content: 'Duplicate Template',
                                    onClick: () => onToggleDuplicateModal(template)
                                  },
                                  {
                                    content: 'Delete Template',
                                    onClick: () => onToggleDeleteModal(template)
                                  }
                                ]}
                              />
                            </div>
                          )}
                        </div>
                      </Panel.LEGACY.Section>
                    </div>
                  </Panel.LEGACY>
                </div>
              );
            }
          })}
        </div>
      </Stack>
    </Box>
  );
};

export default RecentActivity;
